// File: src/pages/Register.js

import React, { useState, useContext } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'
import './Register.css'
import { post } from '../api'   // centralized API helper

export default function RegisterPage() {
  const { login } = useContext(AuthContext)
  const navigate  = useNavigate()

  const [name, setName]         = useState('')
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]       = useState(null)
  const [status, setStatus]     = useState('idle') // 'idle' | 'pending'

  const handleSubmit = async e => {
    e.preventDefault()
    setError(null)
    setStatus('pending')

    try {
      // post() prefixes with /api and attaches JWT if present
      const data = await post('/auth/register', { name, email, password })
      // we expect { token } back
      login(data.token)
      navigate('/', { replace: true })
    } catch (err) {
      // extract backend error message if available
      const msg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        'Registration failed'
      setError(msg)
    } finally {
      setStatus('idle')
    }
  }

  return (
    <div className="register-page">
      <form className="register-form" onSubmit={handleSubmit}>
        <h2>Register</h2>
        {error && <div className="error">{error}</div>}

        <label htmlFor="name">Name</label>
        <input
          id="name"
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          required
        />

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />

        <button type="submit" disabled={status === 'pending'}>
          {status === 'pending' ? 'Signing Up…' : 'Sign Up'}
        </button>

        <p className="alternate">
          Already have an account? <Link to="/login">Log In</Link>
        </p>
      </form>
    </div>
  )
}
